// extracted by mini-css-extract-plugin
export var closeButton = "_2w-3";
export var header = "_2w-0";
export var link = "_2w-1";
export var retryButton = "_2w-2";